<div class="d-flex flex-column h-100">
  <div class="d-flex align-items-center justify-content-center flex-column">
    @if (image) {
      <img src="{{ image }}" alt="Card image" class="ap-mt-spacing-5" />
    }
    <h2>{{ title }}</h2>
  </div>
  <div class="d-flex flex-column gap-1 badges">
    @for (item of items; track trackId(i, item); let i = $index) {
      <div
        class="d-flex align-items-center ap-px-spacing-4 ap-py-spacing-2 badge-wrapper"
        >
        <i class="Appkit4-icon {{ item.icon }} ap-mr-spacing-3" [style.color]="item.iconColor"></i>
        @if (item.link) {
          <a [href]="item.content" target="_blank" class="ap-link badge-text">{{ item.content }}</a>
        } @else {
          @if (item.tooltip) {
            <span
              class="badge"
              ap-tooltip
              tooltipContent="{{ item.tooltip }}"
              tooltipStyle="white-space: pre-line"
              [tooltipId]="'business-card-tooltip-' + i"
              >
              <span class="badge-text">{{ item.content || "N/A" }}</span>
            </span>
          } @else {
            <span class="badge-text">{{ item.content || "N/A" }}</span>
          }
        }
      </div>
    }
    <span class="ap-font-14 ap-pt-spacing-4 ap-mt-spacing-2 description" [hidden]="!description">{{ description }}</span>
    <span class="ap-font-14 ap-pt-spacing-4 ap-mt-spacing-2 description" [hidden]="!notes"
      ><strong>Notes</strong><br />
      {{ notes }}</span
      >
    </div>
  </div>
